
import Sort from "../../../assets/filled/Sort.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SortIcon({ className, dataTestid = "SortIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Sort data-testid={dataTestid} className={classes} {...rest} />
  );
}
